<div class="agpr-topMentionsChart-mention">
    <div class="agpr-topMentionsChart-main">
        <div class="agpr-topMentionsChart-main-firstRow">
            <div class="agpr-topMentionsChart-main-img">
                <img
                    class="agpr-topMentionsChart-main-img-thumbnail"
                    alt=""
                    [agprImageSrc]="outletPhoto"
                    [agprDefaultImage]="imageDefault.SMALL_OUTLET"
                />
            </div>
            <div class="agpr-topMentionsChart-main-headline">
                @if (mention.url && canLinkOut) {
                    <a
                        class="agpr-topMentionsChart-main-headline-link"
                        [href]="mention.tvEyesInstaPlayUrl ? mention.tvEyesInstaPlayUrl : mention.url"
                        target="_blank"
                    >
                        {{ mention.headline }}
                    </a>
                } @else if (mention.isCla || mention.isNla) {
                    <a
                        class="agpr-topMentionsChart-main-headline-link"
                        [href]="mention.viewerUrl"
                        target="_blank"
                    >
                        {{ mention.headline }}
                    </a>
                } @else {
                    {{ mention.headline }}
                }

            </div>
            @if (metadata.mediaType) {
                <div class="agpr-topMentionsChart-main-mediaType">
                    <span
                        role="img"
                        class="agpr-topMentionsChart-main-mediaType-icon"
                        [ngClass]="mention.mediaType.icon"
                        [agprTooltip]="mention.mediaType.tooltip"
                        tooltipPosition="top"
                    ></span>
                </div>
            }

        </div>
        @if (metadata.outlet || metadata.author) {
            <div class="agpr-topMentionsChart-main-secondRow">
                @if (metadata.outlet) {
                    @if (!!outletUrl) {
                        <a
                            class="agpr-topMentionsChart-main-secondRow-link"
                            [href]="outletUrl"
                            target="_blank"
                        >{{ mention.publication.name }}</a>
                    } @else {
                        <div class="agpr-topMentionsChart-outlet">
                            {{ mention.publication.name }}
                        </div>
                    }
                }

                @if (metadata.author) {
                    @if (!!contactUrl) {
                        <a
                            class="agpr-topMentionsChart-main-secondRow-link"
                            [href]="contactUrl"
                            target="_blank"
                        >{{ mention.author.name }}</a>
                    } @else {
                        <div class="agpr-topMentionsChart-author">
                            {{ mention.author.name }}
                        </div>
                    }
                }
            </div>
        }

        @if (mentionCustomization.mentionContent !== mentionContentTypes.headlineOnly) {
            @if (mentionCustomization.highlightKeywords) {
                <div
                    class="agpr-topMentionsChart-main-snippet"
                    [innerHtml]="(bodyText
                        | mentionLinks : mention.mediaType.id
                        | indexHighlight : highlightKeywordsIndices : highlightKeywords
                        | indexHighlightSup)"
                >
                </div>
            } @else {
                <div
                    class="agpr-topMentionsChart-main-snippet"
                    [innerHtml]="bodyText | mentionLinks : mention.mediaType.id"
                ></div>
            }
        }

        @if (mention.isFinancialTimes) {
            <agpr-financial-times-attribution
                [mention]="mention"
            ></agpr-financial-times-attribution>
        }

        @if (mentionCustomization.showInsights && mention.insights?.length) {
            <div class="agpr-topMentionsChart-main-insights">
                <div class="agpr-topMentionsChart-main-insights-name">
                    {{
                        mentionCustomization.insightsNameDisplay === insightsNameEnum.insightsName ?
                        mention.insights[0].name : mentionCustomization.customInsightsName
                    }}
                </div>
                <div
                    class="agpr-topMentionsChart-main-insights-name-content"
                    [innerHtml]="(preContent + mention.insights[0].content + afterContent) | setUlStyle | sanitizeHtml"
                ></div>
            </div>
        }

        @if ((metadata.audienceReach && mention.audienceReach !== null) || (metadata.ave && mention.adValueUsd !== null)) {
            <div class="agpr-topMentionsChart-metrics">
                @if (metadata.audienceReach && mention.audienceReach !== null) {
                    <div class="agpr-topMentionsChart-metric">
                        <div class="agpr-topMentionsChart-metric-line" [style.background]="metadata1Color"></div>
                        <div class="agpr-topMentionsChart-metric-content">
                            <div class="agpr-topMentionsChart-metric-name">
                                {{ 'Reports.topMentions.metadata.audienceReach' | localize }}
                            </div>
                            <div class="agpr-topMentionsChart-metric-number" [style.color]="metadata1Color">
                                {{ mention.audienceReach ? (mention.audienceReach | significantDigits : 1) : 0}}
                            </div>
                        </div>
                    </div>
                }

                @if (metadata.ave && mention.adValueUsd !== null) {
                    <div class="agpr-topMentionsChart-metric">
                        <div class="agpr-topMentionsChart-metric-line" [style.background]="metadata2Color"></div>
                        <div class="agpr-topMentionsChart-metric-content">
                            <div class="agpr-topMentionsChart-metric-name">
                                {{ 'Reports.topMentions.metadata.ave.short' | localize }} ({{ this.mentionCustomization.preferredCurrency }})
                            </div>
                            <div class="agpr-topMentionsChart-metric-number" [style.color]="metadata2Color">
                                {{ ave | significantDigits : 1 }}
                            </div>
                        </div>
                    </div>
                }
            </div>
        }

    </div>

    @if ((metadata.publishedDate && mention.datePublished) || (metadata.wordCount && mention.wordCount) || (metadata.duration && mention.duration)
        || (metadata.domainAuthority && mention.domainAuthority) || (metadata.keywords && mention.contextualKeywords)) {
        <div class="agpr-topMentionsChart-metadata">

            @if (metadata.publishedDate && mention.datePublished) {
                <div class="agpr-topMentionsChart-metadata-item">
                    <label class="agpr-topMentionsChart-metadata-item-label">{{ 'Reports.topMentions.metadata.publishedDate' | localize }}</label>
                    <div class="agpr-topMentionsChart-metadata-item-content">
                        {{ mention.datePublished | changeTimeZone: this.mentionCustomization.timezone : mentionCustomization.dateFormat }}
                    </div>
                </div>
            }

            @if (metadata.wordCount && mention.wordCount) {
                <div class="agpr-topMentionsChart-metadata-item">
                    <label class="agpr-topMentionsChart-metadata-item-label">{{ 'Reports.topMentions.metadata.wordCount' | localize }}</label>
                    <div class="agpr-topMentionsChart-metadata-item-content">{{ mention.wordCount }}</div>
                </div>
            }

            @if (metadata.duration && mention.duration) {
                <div class="agpr-topMentionsChart-metadata-item">
                    <label class="agpr-topMentionsChart-metadata-item-label">{{ 'Reports.topMentions.metadata.duration' | localize }}</label>
                    <div class="agpr-topMentionsChart-metadata-item-content">{{ mention.duration * 1000 | date: 'mm:ss' : 'UTC' }}</div>
                </div>
            }

            @if (metadata.domainAuthority && mention.domainAuthority) {
                <div class="agpr-topMentionsChart-metadata-item">
                    <label class="agpr-topMentionsChart-metadata-item-label">{{ 'Reports.topMentions.metadata.domainAuthority' | localize }}</label>
                    <div class="agpr-topMentionsChart-metadata-item-content">{{ mention.domainAuthority }}</div>
                </div>
            }

            @if (metadata.keywords && mention.contextualKeywords.length) {
                <div class="agpr-topMentionsChart-metadata-item">
                    <label class="agpr-topMentionsChart-metadata-item-label">{{ 'Reports.topMentions.metadata.keywords' | localize }}</label>
                    <div class="agpr-topMentionsChart-metadata-item-content">{{ mention.contextualKeywords }}</div>
                </div>
            }

        </div>
    }
</div>
